export function requireElement<T extends HTMLElement>(id: string): T {
  const element = document.getElementById(id);
  if (!element) throw new Error(`Missing #${id} element`);
  return element as T;
}

export function escapeHtml(value: string): string {
  const div = document.createElement('div');
  div.textContent = value;
  return div.innerHTML;
}

export function makeButton(label: string, onClick: () => void): HTMLButtonElement {
  const button = document.createElement('button');
  button.type = 'button';
  button.textContent = label;
  button.addEventListener('click', onClick);
  return button;
}

const STATUS_LABELS: Record<string, string> = {
  queued: '대기',
  uploading: '업로드 중',
  paused: '일시정지',
  completed: '완료',
  failed: '실패',
  cancelled: '취소됨',
};

export function statusLabel(status: string): string {
  return STATUS_LABELS[status] ?? status;
}
